import type {
  CrmChatProviderKey,
  CrmLeadIntegrationChatTab,
} from '@/api/types/crm/crmLeadFunnels.types'

export const getCrmIntegrationCommunityTabsAriaLabel = (
  provider: CrmChatProviderKey,
): string => {
  if (provider === 'vkontakte') {
    return 'Сообщества ВКонтакте'
  }
  if (provider === 'telegram') {
    return 'Боты Telegram'
  }
  if (provider === 'wazzup') {
    return 'Аккаунты Wazzup'
  }
  return 'Боты MAX'
}

export const getCrmIntegrationCommunityTabLabel = (
  tab: CrmLeadIntegrationChatTab,
  provider: CrmChatProviderKey,
): string => {
  const name = tab.name?.trim()
  if (name) {
    return name
  }

  if (provider === 'vkontakte') {
    return `Сообщество #${tab.integration_id}`
  }

  if (provider === 'wazzup') {
    return `Аккаунт #${tab.integration_id}`
  }

  return `Бот #${tab.integration_id}`
}
